export const SHOW_BIOME_DETAILS = 'SHOW_BIOME_DETAILS';
export const CLEAR_BIOME_DETAILS = 'CLEAR_BIOME_DETAILS';

export function showBiomeDetails(locationInfo) {
  return {
    type: SHOW_BIOME_DETAILS,
    locationInfos: [locationInfo],
  };
}

export function compareBiomeDetails(locationInfos) {
  return {
    type: SHOW_BIOME_DETAILS,
    locationInfos,
  };
}

export function clearBiomeDetails() {
  return {
    type: CLEAR_BIOME_DETAILS,
  };
}



// WEBPACK FOOTER //
// ./src/actions/biomeDetails.js